package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UScreenPadding(
    @SerialName("horizontal") val horizontal: Int? = null,
    @SerialName("vertical") val vertical: Int? = null,
    @SerialName("left") val left: Int? = null,
    @SerialName("right") val right: Int? = null,
    @SerialName("top") val top: Int? = null,
    @SerialName("bottom") val bottom: Int? = null,
)
